<template>
    <tr class="lms__superadmin_customer_edit_workspaces_table_item">
        <td class="lms__superadmin_customer_edit_workspaces_table_item_name">{{workspaceName}}</td>
        <td v-if="false" class="lms__superadmin_customer_edit_workspaces_table_item_emailsender">
            <template v-if="emailSenderFieldEditable">
                <div class="columns is-variable">
                    <div class="column">
                        <form-text
                            :label="''"
                            :name="'lms-superadmin-customer-edit-workspaces-table-item'"
                            :hint-button="true"
                            v-model="emailSender"
                            @emit-hint="disableEmailSenderEditable"
                        >Close edit field</form-text>
                    </div>
                    <div class="column is-narrow">
                        <component-button
                            :name="'lms-superadmin-customer-edit-workspaces-table-item-actions-save-email-sender'"
                            :icon="true"
                            :icon-name="'save'"
                            :theme="'default'"
                            :animate-loading="true"
                            :animate-loading-event-name="'update-workspace-email-sender'"
                            @click="performUpdateEmailSender"
                        ></component-button>
                    </div>
                </div>
            </template>
            <template v-else>
                {{workspaceEmailSender}}
            </template>
        </td>
        <td class="lms__superadmin_customer_edit_workspaces_table_item_actions">
            <div class="columns is-vcentered">
                <div class="column"></div>
                <div class="column is-narrow">
                    <component-button
                        @click="performEmit('emit-edit', workspaceId)"
                        :name="'lms-superadmin-customer-edit-workspaces-table-item-actions-edit'"
                    >{{ $t('lms.customer.viwAction.editButton') }}
                    </component-button>
                </div>
                <div v-if="false" class="column is-narrow">
                    <component-button-menu
                        :buttons="[
                            {
                                key: 'change-sender',
                                name: 'Change sender'
                            }
                        ]"
                        :disabled="emailSenderFieldEditable"
                        @emit-change-sender="enableEmailSenderEditable"
                    ></component-button-menu>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>
import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentButtonMenu from '@/components/default/shared/ComponentButtonMenu'
import FormText from '@/components/default/forms/FormText'

export default {
  name: 'lms-superadmin-customer-edit-workspaces-table-item',
  components: { FormText, ComponentButtonMenu, ComponentButton },
  data () {
    return {
      emailSender: '',
      emailSenderFieldEditable: false
    }
  },
  props: {
    item: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    workspaceId () {
      return this.item.id
    },
    workspaceName () {
      return this.item.name
    },
    workspaceEmailSender () {
      return this.item.emailSender || 'sample@email.org'
    },
    workspaceStatus () {
      return this.item.status
    }
  },
  methods: {
    performEmit (message, value) {
      this.$emit('emit', { message: message, value: value })
    },
    enableEmailSenderEditable () {
      this.emailSender = this.workspaceEmailSender
      this.emailSenderFieldEditable = true
    },
    disableEmailSenderEditable () {
      this.emailSenderFieldEditable = false
    },
    performUpdateEmailSender () {
      setTimeout(() => {
        this.$eventBus.$emit('update-workspace-email-sender')
        this.disableEmailSenderEditable()
      }, 500)
    }
  }
}
</script>
